import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import TelegramIcon from "@mui/icons-material/Telegram";
import { useContext } from "react";
import { homeContext } from "pages/HomeContext";
import axios from "axios";
import { api } from "methods/api";

function FixedIcon() {
  const { homeData } = useContext(homeContext);

  const actions = [
    {
      icon: <WhatsAppIcon sx={{ color: "#fff", fontSize: "32px" }} />,
      name: "WhatsApp",
      bgcolor: "#25d366",
      link: `${homeData?.contactus.whatsup}`,
    },
    {
      icon: <TelegramIcon sx={{ color: "#fff", fontSize: "32px" }} />,
      name: "Telegram",
      bgcolor: "#279dd8",
      link: `${homeData?.contactus.telegram}`,
    },
  ];

  function bookTravel(name: string) {
    axios
      .post(api(`book-count`), { title: name })
      .catch((err) => {});
  }

  return (
    <Box
      sx={{
        position: "fixed",
        bottom: "20px",
        right: "20px",
        display: "flex",
        flexDirection: "column",
        gap: 2,
        zIndex: 9999,
      }}
    >
      {actions.map((action, index) => (
        <IconButton
          key={index}
          onClick={() => {
            bookTravel(action.name);
            window.open(action.link, "_blank");
          }}
          sx={{
            bgcolor: action.bgcolor,
            width: 56,
            height: 56,
            "&:hover": {
              bgcolor: action.bgcolor,
              opacity: 0.85,
            },
          }}
        >
          {action.icon}
        </IconButton>
      ))}
    </Box>
  );
}

export default FixedIcon;
